import bodyClass from "discourse/helpers/body-class";
import { i18n } from "discourse-i18n";
import CirclesFormProfileFields from "../../components/circles/form-profile-fields";

const CirclesNew = <template>
  {{bodyClass "circles-new-page"}}

  <section>
    <h1>{{i18n "discourse_circles.form.new.title"}}</h1>
    <hr />
    <CirclesFormProfileFields
      @model={{@model}}
      @onAfterSave={{@controller.onAfterSave}}
      @saveBtnText="discourse_circles.form.new.create"
    />
  </section>
</template>;

export default CirclesNew;
